module.exports = __webpack_public_path__ + "41b90f377329b114e1d5e66eebc1dcd2.pdf";